module.exports = __webpack_public_path__ + "static/img/HuangMu_lianbai_sumAndautAandWin.e1a96450.png";